import React from "react";
import serviceData from "../data/serviceData";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import {
  FaDatabase,
  FaWifi,
  FaNetworkWired,
  FaShieldAlt,
  FaServer,
  FaTools,
} from "react-icons/fa";

const serviceIcons = [
  FaDatabase,
  FaWifi,
  FaNetworkWired,
  FaShieldAlt,
  FaServer,
  FaTools,
];

const ServicesSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isMobile ? "3rem 1.5rem" : isTablet ? "4.5rem 2rem" : "6rem 4rem",
  };

  const sectionTitle = {
    fontSize: isMobile ? "26px" : "38px",
    fontWeight: 700,
    color: "#1E1B4B",
    marginBottom: "20px",
    textAlign: "center",
  };

  const paragraphStyle = {
    fontSize: isMobile ? "14px" : "16px",
    lineHeight: "28px",
    color: "#4B5563",
    maxWidth: "850px",
    margin: "0 auto",
    textAlign: "center",
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile
      ? "1fr"
      : isTablet
      ? "repeat(2, 1fr)"
      : "repeat(3, 1fr)",
    gap: "30px",
    marginTop: isMobile ? "3rem" : "5rem",
  };

  const cardStyle = {
    padding: "30px",
    borderRadius: "22px",
    background:
      "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(250,247,255,0.96) 100%)",
    border: "1px solid rgba(157, 78, 221, 0.12)",
    transition: "transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease",
    height: "100%",
    position: "relative",
    boxShadow: "0 14px 35px rgba(15, 10, 31, 0.05)",
  };

  return (
    <section
      style={{
        background:
          "radial-gradient(circle at top right, rgba(157, 78, 221, 0.16), transparent 24%), radial-gradient(circle at bottom left, rgba(106, 13, 173, 0.1), transparent 26%), linear-gradient(180deg, #f5f3ff 0%, #fcfbff 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: isMobile ? "40px" : "60px",
          right: isMobile ? "-10px" : "40px",
          width: isMobile ? "120px" : "180px",
          height: isMobile ? "120px" : "180px",
          borderRadius: "50%",
          background: "rgba(157, 78, 221, 0.1)",
          filter: "blur(24px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "20px" : "30px",
          left: isMobile ? "-20px" : "30px",
          width: isMobile ? "120px" : "180px",
          height: isMobile ? "120px" : "180px",
          borderRadius: "50%",
          background: "rgba(80, 42, 140, 0.08)",
          filter: "blur(26px)",
        }}
      />
      <div style={containerStyle}>
        <div style={{ position: "relative", zIndex: 1 }}>
          <h2 style={sectionTitle}>Integrated Technology Solutions</h2>

          <p style={paragraphStyle}>
            At InnoByte, we deliver end-to-end system integration services
            across data centres, enterprise Wi-Fi, structured cabling,
            electronics hardware, security systems, and core network
            infrastructure.
          </p>

          <div style={gridStyle}>
            {serviceData.map((service, index) => {
              const Icon = serviceIcons[index % serviceIcons.length];

              return (
                <div
                  key={index}
                  style={cardStyle}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow =
                      "0 18px 40px rgba(106, 13, 173, 0.14)";
                    e.currentTarget.style.borderColor =
                      "rgba(157, 78, 221, 0.24)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 14px 35px rgba(15, 10, 31, 0.05)";
                    e.currentTarget.style.borderColor =
                      "rgba(157, 78, 221, 0.12)";
                  }}
                >
                  <div
                    style={{
                      width: isMobile ? "52px" : "58px",
                      height: isMobile ? "52px" : "58px",
                      borderRadius: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "18px",
                      background:
                        "linear-gradient(135deg, rgba(106, 13, 173, 0.14), rgba(157, 78, 221, 0.22))",
                      color: "#6A0DAD",
                      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.7)",
                    }}
                  >
                    <Icon size={24} />
                  </div>

                  <h3
                    style={{
                      fontWeight: 600,
                      color: "#6A0DAD",
                      marginBottom: "15px",
                      fontSize: isMobile ? "20px" : "22px",
                      lineHeight: isMobile ? "28px" : "30px",
                    }}
                  >
                    {service.title}
                  </h3>

                  <p
                    style={{
                      fontSize: "15px",
                      lineHeight: "26px",
                      color: "#4B5563",
                      marginBottom: "20px",
                    }}
                  >
                    {service.description}
                  </p>

                  {service.solutions && (
                    <div>
                      {service.solutions.slice(0, 4).map((item, i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "14px",
                            marginBottom: "10px",
                            color: "#1F2937",
                          }}
                        >
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              background:
                                "linear-gradient(90deg, #6A0DAD, #9D4EDD)",
                              borderRadius: "50%",
                              marginRight: "12px",
                              boxShadow:
                                "0 0 0 4px rgba(157, 78, 221, 0.08)",
                            }}
                          />
                          {item}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
